const data = [  
            {   planId:'Hydro_D',
                planTitle:{FR:'Hydro-Quebec résidentiel (Tarif D)', EN:'Hydro-Québec residential (D Rate)'},
                plan:[
                    {type:'0',tempCondition:'0.0',tempThreshold:-14,startMonth:1,endMonth:12,startDay:1,endDay:7,startHour:0,endHour:24,price:0.0938},
                    ],
            },

            {   planId:'Hydro_D_Flex',
            planTitle:{FR:'Hydro-Quebec résidentiel (Flex D)', EN:'Hydro-Québec residential (D Flex)'},
            plan:[
                {type:'0',tempCondition:'0',tempThreshold:-14,startMonth:4,endMonth:11,startDay:1,endDay:7,startHour:0,endHour:24,price:0.0938},
                {type:'0',tempCondition:'0',tempThreshold:-14,startMonth:1,endMonth:3,startDay:1,endDay:7,startHour:0,endHour:24,price:0.0736},
                {type:'0',tempCondition:'0',tempThreshold:-14,startMonth:12,endMonth:12,startDay:1,endDay:7,startHour:0,endHour:24,price:0.0736},
                ],
            },           

            {   planId:'Hydro_DT',
            planTitle:{FR:'Hydro-Quebec bi-énergie (Tarif DT)', EN:'Hydro-Québec bi-energy (DT Rate)'},
            plan:[
                {type:'0',tempCondition:'0',tempThreshold:-14,startMonth:4,endMonth:11,startDay:1,endDay:7,startHour:0,endHour:24,price:0.0437},
                {type:'1',tempCondition:'0',tempThreshold:-15,startMonth:1,endMonth:12,startDay:1,endDay:7,startHour:0,endHour:24,price:0.2555},
                ],
            },
            ]
export default data;



// WEBPACK FOOTER //
// ./src/views/configuration/ElectricalPlanDefinition.js